<span *ngIf="date" class="citation-due-date">
    ({{'collection.add.action.due' | translate}}:
    <span class="item-due-date">{{date | customerDate}})</span>
</span>